import React from 'react';
import { useParams } from 'react-router-dom';
import ListFromApi from '../../../ListFromApi';

import { Row, Col } from 'reactstrap';

import Task from './Task';

function Tasks(props) {
    const { id } = useParams();

    return (
        <Row>
            <Col>
                <h4>Feladatok</h4>
                <ListFromApi url={`/events/${id}/tasks`}
                    elementType={Task}
                    errorMessage="A feladatok letöltése sikertelen."
                    callback={props.callback}
                />
            </Col>
        </Row>
    );
}

export default Tasks;